import React, { useState, useEffect } from "react";
import { isNumber } from "lodash";
import { Typography, IconButton, makeStyles } from "@material-ui/core";
import { Add, Remove } from "@material-ui/icons";
import { Container } from "./styles.js";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "3rem",
    color: theme.palette.primary.dark,
    marginLeft: 20
  },
}));

const Counter = ({ text, onClickCounter, valueDefault = 0, disabled }) => {
  const [value, setValue] = useState(0);
  const classes = useStyles();

  const handleChange = (count) => {
    let newValue = value + count;
    newValue = newValue >= 0 ? newValue : 0;
    setValue(newValue >= 0 ? newValue : 0);
    onClickCounter(newValue >= 0 ? newValue : 0);
  };

  useEffect(() => setValue(valueDefault), [valueDefault]);

  return (
    <Container>
      <Typography variant="subtitle1">{text}</Typography>
      <IconButton
        aria-label="remove"
        style={{ marginLeft: 20 }}
        onClick={() => handleChange(-1)}
        disabled={disabled}
      >
        <Remove />
      </IconButton>
      <Typography className={classes.title}>
        {(!isNumber(value) && 0) || value}
      </Typography>
      <IconButton
        aria-label="add"
        style={{ marginLeft: 20 }}
        onClick={() => handleChange(+1)}
        disabled={disabled}
      >
        <Add />
      </IconButton>
    </Container>
  );
};

Counter.defaultProps = {
  onClick: () => {},
};

export default Counter;
